import { jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { isFunction } from "../../../utils/type-checking/type-checking.es.js";
import { memo } from "react";
import { IconButton } from "../../icon-button/icon-button.es.js";
function ModalBarIconBuilder({
  onClick,
  icon,
  color,
  ...rest
}) {
  if (!icon) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const isClickable = isFunction(onClick);
  return /* @__PURE__ */ jsx(IconButton, { disableRipple: !isClickable, disableTouchRipple: !isClickable, sx: {
    cursor: isClickable ? "pointer" : "default"
  }, color, onClick, ...rest, children: icon });
}
const ModalBarIcon = memo(ModalBarIconBuilder);
export {
  ModalBarIcon
};
//# sourceMappingURL=modal-icon.es.js.map
